<template>
	<div class="pdf-viewer">
		<div class="pdf-status" v-if="loading">
			<i class="iconfont icon-dengdai"></i>
			<span>PDF 加载中…</span>
		</div>
		<div class="pdf-status pdf-error" v-else-if="error">
			<i class="iconfont icon-xiaolian"></i>
			<span>PDF 加载失败</span>
			<a class="pdf-download" :href="src" target="_blank" rel="noopener noreferrer">点此下载查看</a>
		</div>
		<div class="pdf-pages" ref="pages"></div>
	</div>
</template>

<script>
// pdfjs-dist 2.x legacy 构建：兼容老 webpack / 微信 X5 等内核
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'
pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/legacy/build/pdf.worker.entry')

export default {
	name: 'PdfViewer',
	props: {
		src: { type: String, required: true },
	},
	data() {
		return {
			loading: true,
			error: false,
		}
	},
	watch: {
		src() { this.render() },
	},
	mounted() {
		this.render()
	},
	methods: {
		async render() {
			if (!this.src) return
			this.loading = true
			this.error = false
			const container = this.$refs.pages
			if (container) container.innerHTML = ''
			try {
				const loadingTask = pdfjsLib.getDocument({
					// 跨域文件服务器已返回 Access-Control-Allow-Origin:*
					url: this.src,
				})
				const pdf = await loadingTask.promise
				// 移动端按容器宽度渲染，保证清晰
				const containerWidth = (container && container.clientWidth) || (window.innerWidth - 60) || 320
				for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
					const page = await pdf.getPage(pageNum)
					const baseViewport = page.getViewport({ scale: 1 })
					const scale = containerWidth / baseViewport.width
					const viewport = page.getViewport({ scale })
					const canvas = document.createElement('canvas')
					const ctx = canvas.getContext('2d')
					// 高清屏（含部分安卓 X5）提升清晰度
					const dpr = Math.min(window.devicePixelRatio || 1, 2)
					canvas.width = Math.floor(viewport.width * dpr)
					canvas.height = Math.floor(viewport.height * dpr)
					canvas.style.width = '100%'
					canvas.style.display = 'block'
					canvas.style.marginBottom = '12px'
					ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
					container.appendChild(canvas)
					await page.render({ canvasContext: ctx, viewport }).promise
				}
				this.loading = false
			} catch (e) {
				console.log('PDF render error:', e)
				this.loading = false
				this.error = true
			}
		},
	},
}
</script>

<style scoped>
.pdf-viewer { width: 100%; }
.pdf-pages { width: 100%; }
.pdf-pages canvas { background: #fff; border-radius: 6px; box-shadow: 0 1px 6px rgba(0,0,0,.12); }
.pdf-status { display: flex; align-items: center; justify-content: center; gap: .5rem; padding: 2.5rem 1rem; color: #94a3b8; }
.pdf-status i { font-size: 1.4rem; }
.pdf-error { flex-direction: column; gap: .6rem; }
.pdf-download { color: #2563eb; text-decoration: underline; }
</style>

<style>
@import '../assets/css/alibaba.css';
</style>